$(document).ready(function () {
  $(".article-wrapper").slick({
    dots: false,
    arrows: true,
    prevArrow:
      '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left slick-prev slick-arrow" viewBox="0 0 7 11"><path d="M5.5.037a1.5 1.5 0 0 1 1.06 2.56l-2.94 2.94 2.94 2.94a1.5 1.5 0 0 1-2.12 2.12l-4-4a1.5 1.5 0 0 1 0-2.12l4-4A1.5 1.5 0 0 1 5.5.037z" fill="#fff" class="layer"/></svg>',
    nextArrow:
      '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right slick-next slick-arrow" viewBox="0 0 7 11"><path d="M1.5 11A1.5 1.5 0 0 1 .44 8.44L3.38 5.5.44 2.56A1.5 1.5 0 0 1 2.56.44l4 4a1.5 1.5 0 0 1 0 2.12l-4 4A1.5 1.5 0 0 1 1.5 11z" fill="#fff"/></svg>',
    infinite: true,
    autoplay: false,
    autoplaySpeed: 2000,
    speed: 1000,
    draggable: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          slidesToScroll: 1,
        },
      },
    ],
  });
  function initTabs() {
    $(".featured-products_wrapper").slick({
      dots: false,
      arrows: true,
      prevArrow:
        '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left slick-prev slick-arrow" viewBox="0 0 7 11"><path d="M5.5.037a1.5 1.5 0 0 1 1.06 2.56l-2.94 2.94 2.94 2.94a1.5 1.5 0 0 1-2.12 2.12l-4-4a1.5 1.5 0 0 1 0-2.12l4-4A1.5 1.5 0 0 1 5.5.037z" fill="#fff" class="layer"/></svg>',
      nextArrow:
        '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right slick-next slick-arrow" viewBox="0 0 7 11"><path d="M1.5 11A1.5 1.5 0 0 1 .44 8.44L3.38 5.5.44 2.56A1.5 1.5 0 0 1 2.56.44l4 4a1.5 1.5 0 0 1 0 2.12l-4 4A1.5 1.5 0 0 1 1.5 11z" fill="#fff"/></svg>',
      infinite: true,
      autoplay: false,
      autoplaySpeed: 2000,
      speed: 1000,
      draggable: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            centerMode: false,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }
  initTabs();
  var tabs = $("[data-tab-target]");
  var tabsWidth = 0;
  $("[data-tab-target]").on("click", function (e) {
    var target = $(
      ".featured-products__tab-content [data-tab-id=" +
        $(this).attr("data-tab-id") +
        "]"
    );
    $(tabs).removeClass("active");
    $(".featured-products__tab-content .tab-content").hide();
    $(this).addClass("active");
    $(target).addClass("active").show();
    $(target).find(".featured-products_wrapper").slick("refresh");
  });
});
